import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const CustomPlaybookExportAction = createAsyncThunk("customPlaybookExport",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostDownload(urls?.exportCustomPlaybooks, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const customPlaybookExportSlice = createSlice({
    name: "customPlaybookExport",
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null
    },
    reducers: {
        customPlaybookExportReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [CustomPlaybookExportAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [CustomPlaybookExportAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [CustomPlaybookExportAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { customPlaybookExportReset } = customPlaybookExportSlice.actions
export default customPlaybookExportSlice.reducer;
